// Link internal(scrollto) v1.1
// Created: 02/2017
// Updated:
// Required: Revealizr

// TO DO
// Scroll within fixed element is not working properly
// Already tried : offset.top, getBoundingClientRect().y
// The value returned by offset.top on a element within a modal is the same as window.scrollY

// Usage 
// $(window).link_internal(}; To catch the hash in the URL on load
// $('selector').link_internal(); // Target every links/buttons 

// Prevent automatic scrolling Chrome when there's a hash in the URL
if( 'scrollRestoration' in history && window.location.hash !== '' ) {
	history.scrollRestoration = 'manual';
} else {
	history.scrollRestoration = 'auto';
}

(function($) {
	'use strict';
	let linkInternalFirstPageLoad = true;
	$.fn.link_internal = function(options) {
		
		// Default settings
		var settings = $.extend({
			$containerScroll: ( document.querySelector('html').classList.contains('edge') || document.querySelector('html').classList.contains('ios') ) ? $('body') : $('html'),
			$customTarget: '', // Object
			targetIsContainer: false,
			positionModifier: 0,
			positionModifierMultiplier: 1,
			scrollValue: null,
			speedAnimation: 300
		}, options );

		var calculatePositionModifierHeight = function($elements) {
			let height = 0;
			$elements.each(function(){
				height += $(this).outerHeight();
			});

			return height;
			
		};
		
		return this.each(function(index) {
			var $app = $(this);
			var hash = ( window.location.hash !== undefined )? window.location.hash : null;
			let $target = null;
			let speedAnimation = 0;
			let scrollValue = settings.scrollValue !== null ? settings.scrollValue : null;
			
			if( $app.parent().length > 0 ) {
				$app.on('click', function(event){
					if( this.getAttribute('href') !== null ) {
						event.preventDefault();
						event.stopPropagation();
					}

					if( $app.attr('data-href') !== undefined ) {
						history.pushState(null, "", `${$app.attr('data-href')}` );
					}else if( $app.attr('href') !== undefined  ) {
						history.pushState(null, "", `${$app.attr('href')}` );
					}
					initScroll();
				});
			} else if( ( hash != undefined && linkInternalFirstPageLoad === true ) || typeof settings.$customTarget === 'object' ) {
				initScroll();
			}
			
			function initScroll() {
				
				if( linkInternalFirstPageLoad === false ) {
					speedAnimation = settings.speedAnimation;
				}
				
				if( typeof settings.$customTarget === 'object' ) {
					if( settings.targetIsContainer === true ) {
						$target = settings.$customTarget.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex]').not(':disabled').not(':hidden').first();
					} else {
						$target = settings.$customTarget;
					}
				} else {
					$target = $( window.location.hash );
				}

				if( $target.length === 0 ) {
					return false;
				}
				
				let positionModifier;
				
				if ( $(settings.positionModifier) !== null ) {
					positionModifier = ( typeof settings.positionModifier === 'string' )? calculatePositionModifierHeight($(settings.positionModifier)) : settings.positionModifier;
				} else {
					positionModifier = 0;
				}

				if( scrollValue === null ){
					scrollValue = ( $target.offset() != undefined )? parseFloat( $target.offset().top ) - ( parseFloat( positionModifier ) * parseFloat( settings.positionModifierMultiplier ) ) : 0;
				}

				focus();
				
				settings.$containerScroll.animate({
					scrollTop: scrollValue
				}, speedAnimation );	
			}
			
			function focus() {
				const target = $target[0];

				if( target.matches('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex]') === false ) {
					target.setAttribute('tabindex', -1);
				}

				target.focus({preventScroll:true});
			}

			linkInternalFirstPageLoad = false;
		});
	}
	
})(jQuery);